import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { CreditReport } from "./types";

const initialState = {
  availableCredit: 0,
  creditPurchased: 0,
  eventsPurchased: 0,
  totalCreditUsed: 0,
  totalPurchaseAmount: 0,
  totalSeatsPurchased: 0,
};

export const creditReportState = createSlice({
  name: "creditReport",
  initialState,
  reducers: {
    set: (state, action: PayloadAction<CreditReport>) => {
      return action.payload;
    },

    setAvailableCredit: (state, action: PayloadAction<number>) => {
      state.availableCredit = action.payload;
    },
  },
});
